import React from "react";
import { Phone, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "2250505352727";
const PHONE_NUMBER = "+22505053527272";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
          "Bonjour KMS Services Plus, je souhaite un renseignement."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
        className="group w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300 animate-floaty"
      >
        <MessageCircle size={26} strokeWidth={1.8} />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0A1128] text-white text-xs font-bold px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp
        </span>
      </a>
      <a
        href={`tel:${PHONE_NUMBER}`}
        data-testid="floating-call-btn"
        aria-label="Appeler"
        className="group w-14 h-14 rounded-full bg-[#D90429] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300"
      >
        <Phone size={22} strokeWidth={2} />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0A1128] text-white text-xs font-bold px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Appeler maintenant
        </span>
      </a>
    </div>
  );
}
